import { Color } from 'csstype';
import React from 'react';
import styled from 'styled-components';
import { getPlayerIcon } from './../utility/PlayerDataGenerator';

interface Props {
    icon: number;
    color: Color;
}
export class Avatar extends React.Component<Props> {
    public render() {
        return (
            <AvatarWrapper>
                <AvatarOverlay color={this.props.color}/>
                <AvatarImage src={ getPlayerIcon(this.props.icon)}/>
            </AvatarWrapper>
        )
    }
}
const AvatarWrapper = styled.div`
    position:relative;
    width:100%;
    height:100%;
    border-radius: 10px;
`;
const AvatarImage = styled.img`
    position: absolute;
    width:100%;
    height:100%;
    z-index: 3;
    border-radius: 10px;
`;

const AvatarOverlay = styled.div<{color: string}>`
    content: "";
    position: absolute;
    width:100%;
    height:100%;
    background-color:${p => p.color};
    mix-blend-mode:multiply;
    z-index: 4;
    border-radius: 10px;
`;


// WEBPACK FOOTER //
// ./src/Components/Avatar.tsx